import { render } from "./salesHistoryTable.vue?vue&type=template&id=427605cc"
import script from "./salesHistoryTable.vue?vue&type=script&lang=js"
export * from "./salesHistoryTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__